<template>
	<Row class="flex-align-center width-100">
		<Row class="flex-align-center flex-justify-space-between width-100">
			<Row class="flex-align-center">
				<Col class="flex-centerize mail-icon-container avatar" :style="mailIconContainerStyle">
					<SIcon :width="13" :height="13" name="email-user-combo" />
				</Col>
				<h5 class="email-invitation-text reg">{{ item.email }}</h5>
			</Row>
			<h5 class="will-be-invited-text reg">User will be invited</h5>
		</Row>
	</Row>
</template>
<script>
export default {
	name: 'ComboboxEmailItem',
	props: { item: { type: Object }, size: { type: Number, default: 35 } },
	computed: {
		mailIconContainerStyle() {
			return { 'min-width': this.size + 'px', 'min-height': this.size + 'px' };
		},
	},
};
</script>
<style scoped lang="scss">
.email-invitation-text {
	color: #292829;
	font-weight: 300;
}
.avatar {
	margin-right: 10px;
}
.mail-icon-container {
	border-radius: 50%;
	background: #f6f8fb;
	border: 1px solid #d6ddea;
}
.will-be-invited-text {
	font-weight: 300;
	color: #6b7787;
	font-style: italic;
	letter-spacing: 0px;
}
</style>
